import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector, useDispatch } from "react-redux";
import { SetParserHeadExtremeFurtherDetailsAction } from "../../../redux/actions/companyAction";

function ParserHeadDetails() {
    const [loading, setloading] = useState(true);
    const [selectedRow, setselectedRow] = useState([]);
    const dispatch = useDispatch();

    const parseHeadFurtherDetails = useSelector((state) => state.companySlice?.parseHeadFurtherDetails);

    const onRowSelect = (event) => {
        dispatch(SetParserHeadExtremeFurtherDetailsAction(event.data));
    };

    const statusBody = (rowData) => {
        return <div>{rowData?.isMandatory === "Y" ? "Yes" : "No"}</div>;
    };

    useEffect(() => {
        if (parseHeadFurtherDetails) {
            setloading(false);
        }
    }, [parseHeadFurtherDetails]);

    return (
        <div>
            <div className="card p-datatable-sm">
                <DataTable
                    header="Parser Head Details"
                    selection={selectedRow}
                    onSelectionChange={(e) => setselectedRow(e.value)}
                    selectionMode="single"
                    dataKey="parserDetailId"
                    onRowSelect={onRowSelect}
                    loading={loading}
                    paginator
                    rows={5}
                    value={parseHeadFurtherDetails}
                    emptyMessage="No data found."
                >
                    <Column filter field="columnName" header="Column Name" />
                    <Column filter field="columnType" header="Column Type" />
                    <Column filter field="fixedLength" header="Fixed Length" />
                    <Column filter field="maxLength" header="Max Length" />
                    <Column filter field="minLength" header="Min Length" />
                    <Column filter field="isMandatory" body={statusBody} header="Mandatory" />
                </DataTable>
            </div>
        </div>
    );
}

export default ParserHeadDetails;
